import { ActionTypes } from "../actions/act_types"
import combineReducers, {
  StateFromReducersMapObject,
} from "../../utils/combine-reducer"
import ICustoms from "../../models/product/customs"
import IVat from "../../models/product/vat"
import ITerritoi from "../../models/product/territoi"
import { ITax } from "../../models/bo"
import { IDropdownOption } from "../../ui/product-form/_reducers/_utils/product-form-types"

const customs = (state: ICustoms[] = [], action: any) => {
  switch (action.type) {
    case ActionTypes.UPDATE_CUSTOMS:
      return action.data
    default:
      return state
  }
}

const vat = (state: IVat[] = [], action: any) => {
  switch (action.type) {
    case ActionTypes.UPDATE_VAT:
      return action.data
    default:
      return state
  }
}

const warranty = (state: IDropdownOption[] = [], action: any) => {
  switch (action.type) {
    case ActionTypes.UPDATE_WARRANTY_LIST:
      return action.data
    default:
      return state
  }
}

const taxes = (state: ITax[] = [], action: any) => {
  switch (action.type) {
    case ActionTypes.UPDATE_TAXES:
      return action.data
    default:
      return state
  }
}

const territoi = (state: ITerritoi[] = [], action: any) => {
  switch (action.type) {
    case ActionTypes.UPDATE_TERRITOI:
      return action.data
    default:
      return state
  }
}

const brands = (state: string[] = [], action: any) => {
  switch (action.type) {
    case ActionTypes.UPDATE_BRANDS:
      return action.data
    default:
      return state
  }
}

const createTree = (treeName: string) => {
  const intitialized = (state = false, action: any) => {
    if (action.treeName !== treeName) {
      return state
    }

    switch (action.type) {
      case ActionTypes.LOAD_TREE:
        return true
      case ActionTypes.START_FETCHING_TECH_FAMILIES:
      case ActionTypes.FETCH_TECH_FAMILIES_FAIL:
        return false
      default:
        return state
    }
  }

  const isLoading = (state = false, action: any) => {
    if (action.treeName !== treeName) {
      return state
    }

    switch (action.type) {
      case ActionTypes.START_FETCHING_TECH_FAMILIES:
        return true
      case ActionTypes.LOAD_TREE:
      case ActionTypes.FETCH_TECH_FAMILIES_FAIL:
        return false
      default:
        return state
    }
  }

  const filter = (state = "", action: any) => {
    if (action.treeName !== treeName) {
      return state
    }

    switch (action.type) {
      case ActionTypes.SET_FILTERED_DATA:
      case ActionTypes.LOAD_TREE:
        return action.filter
      case ActionTypes.RESET_TREE:
        return ""
      default:
        return state
    }
  }

  const data = (state = {}, action: any) => {
    if (action.treeName !== treeName) {
      return state
    }

    switch (action.type) {
      case ActionTypes.RESET_TREE:
      case ActionTypes.LOAD_TREE:
        return action.data
      default:
        return state
    }
  }

  const filteredData = (state = {}, action: any) => {
    if (action.treeName !== treeName) {
      return state
    }

    switch (action.type) {
      case ActionTypes.SET_FILTERED_DATA:
      case ActionTypes.RESET_TREE:
      case ActionTypes.LOAD_TREE:
        return action.data
      default:
        return state
    }
  }

  const rawData = (state = [], action: any) => {
    if (action.treeName !== treeName) {
      return state
    }

    switch (action.type) {
      case ActionTypes.LOAD_TREE:
        return action.rawData
      default:
        return state
    }
  }

  const treeReducers = {
    intitialized,
    isLoading,
    filter,
    data,
    filteredData,
    rawData,
  }

  return combineReducers<typeof treeReducers>(treeReducers)
}

const reducers = {
  comTree: createTree("comTree"),
  techTree: createTree("techTree"),
  vat,
  warranty,
  taxes,
  customs,
  territoi,
  brands,
}

export type MiscellaneousState = StateFromReducersMapObject<typeof reducers>

export default combineReducers<typeof reducers>({
  ...reducers,
})
